import { z } from 'zod';
import { DataSyncChildRecordTypeSchema } from '../inputTypeSchemas/DataSyncChildRecordTypeSchema'
import { AdditionalDataSyncSettingsSchema } from '../inputTypeSchemas/AdditionalDataSyncSettingsSchema'

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC CHILD RECORD SETTING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncChildRecordSettingSchema = z.object({
  childRecordType: DataSyncChildRecordTypeSchema,
  setting: AdditionalDataSyncSettingsSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  integrationId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CoreIntegrationDataSyncChildRecordSetting = z.infer<typeof CoreIntegrationDataSyncChildRecordSettingSchema>

export default CoreIntegrationDataSyncChildRecordSettingSchema;
